import React from 'react';
import { LegendRow } from "../../Legend";
import st from "./CropsRowRenderer.module.scss";

type CropsRowRendererProps = {
	row: LegendRow
}

const CropsRowRenderer = (props: CropsRowRendererProps) => {
	const { row } = props;

	return (
		<div className={st['row']}>
			{row.values.map((rowItem, ind) =>
				<div className={st['row-item']}
					 style={{ maxWidth: ind === 0 ? 'calc(60% - 12px)' : 'calc(40% - 12px)' }}
					 key={ind + `${row.id}`}
				>
					{rowItem}
				</div>
			)}
		</div>
	)
}

export default CropsRowRenderer;